<template>
    <div class="purchase-aids-content">
        
        <div class="zblock-purchase-aids_container" :style="windowWidth > 700 ? backgroundStyles : ''">
            <div class="zblock-purchase-aids_content">
                <div class="content-text" :inner-html.prop="blockdatas.description"></div>
                <a :href="blockdatas.link" class="btn btn--red btn--fill content-cta" >{{ blockdatas.label_link}}</a>
            </div>
        </div>

        <div class="bg-grey"></div>

    </div>
</template>

<script>
export default {
    name: 'PurchaseAids',

    props: ["blockdatas"],

    data() {
        return {
            windowWidth : window.innerWidth,
        };
    },

    computed: {
        backgroundStyles() {
        return {
            "background-image": `url(${this.blockdatas.background_image})`,
            "background-size": "cover",
            "background-position-y": "10%",
        };
        },
    },

    methods: {
        onResize() {
            this.windowWidth = window.innerWidth;
        },
    },

    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
        })
    },

    beforeDestroy() { 
        window.removeEventListener('resize', this.onResize); 
    },
    
}
</script>

<style lang="scss" scoped>
    .purchase-aids-content {
        padding: 30px 0;
        display: flex;
        align-items: center;
        position: relative;
    }

    .zblock-purchase-aids_container {
        display: flex;
        justify-content: end;
        align-items: center;
        width: 75vw;
        min-height: 450px;
        margin: 0 auto;
        border-radius: 10px;
        
        @media ($mq-large-desktop) {
               width: 70vw;
            }

        .zblock-purchase-aids_content {
            position: absolute;
            left: 20%;
            bottom: 10%;

            padding: 50px 45px;
            width: 60%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            background-color: $color-white;
            border-radius: 10px;

            @media ($mq-desktop) {
                width: 40%;
                margin-right: 40px;
                height: 80%;
                width: 50%;
                position: initial;
            }

            @media ($mq-large-desktop) {
               width: 35%; 
            }

            .content-text {
                font-size: 3rem;
                margin-bottom: 25px;
            }

            .content-cta {
                max-width: 250px;
                font-size: 12px;
            }
        }
    }

    .bg-grey {
        position: absolute;
        bottom: 0;
        height: 50%;
        width: 100%;
        background-color: #FAFAFA;
        z-index: -1;
    }

    .purchase-aids {
        @media ($mq-phone) {
            .purchase-aids-content {
                height: auto;
                padding: 25px 0;
                background-color: #FAFAFA;
            }

            .zblock-purchase-aids_container {
                width: auto;
                justify-content: center;
                
                .zblock-purchase-aids_content {
                    position: initial;
                    width: 80%;
                }
            } 
        }
    }
    
</style>